import isAppWhiteLabeled from '../../app/utils/isAppWhiteLabeled'
import Card from '../../layout/components/card/Card'

import OutletListSkeleton from './OutletListSkeleton'
import NewOrderOutletDetailsSkeleton from './newOrder/NewOrderOutletDetailsSkeleton'
import styles from './OutletsListPageSkeleton.module.scss'

export default function OutletsListPageSkeleton() {
  const isWhiteLabeled = isAppWhiteLabeled()

  return (
    <div className={styles.wrapper}>
      {/* Left Container */}
      <OutletListSkeleton containerClassName={styles.skeletonContainer} />
      {/* Right Container */}
      {isWhiteLabeled && (
        <div className={styles.rightContainer}>
          <Card className={styles.newOrderCard}>
            <NewOrderOutletDetailsSkeleton />
          </Card>
        </div>
      )}
    </div>
  )
}
